// Shared English terms. Key: exact Macedonian text passed to t().
const en = {
  'Јазик': 'Language',
  'Отвори мени': 'Open menu',
  'Добредојдовте во Pulse': 'Welcome to Pulse',
  'Одјава': 'Log out',
  'Аватар на корисникот': 'User avatar',
  'Зачувај': 'Save',
  'Зачувај промени': 'Save changes',
  'Откажи': 'Cancel',
  'Избриши': 'Delete',
  'Уреди': 'Edit',
  'Преглед': 'Preview',
  'Додади': 'Add',
  'Пребарај': 'Search',
  'Вчитување...': 'Loading...',
  'Грешка': 'Error',
  'Статус': 'Status',
  'Датум': 'Date',
  'Вкупно': 'Total',
  'Количина': 'Quantity',
  'Цена': 'Price',
  'Во ред': 'OK',
  'Потврди': 'Confirm',
  'Потребна е најава': 'Authentication required',
  'Ве молиме најавете се повторно.': 'Please log in again.',
};

export default en;
